import React from 'react';
import './Marquee.css';

const TITLES = [
  'Ambition', 'Awakening', 'Boat', 'Can you face your Self',
  'Confrontation', 'Could Not Follow', 'Cradle of Clouds', 'Fairy',
  'Free', 'House', 'Knowledge', 'Laundry', 'Letters',
  'Nothing left to loose', 'Played', 'Prayer', 'Resonance',
  'The Long Minute', 'The Summons', 'Trust', 'Unclaimed',
  'Vesper', 'Waiting', 'Where Time Crawls', 'Windbound',
];

export default function Marquee() {
  const items = [...TITLES, ...TITLES];
  return (
    <div className="marquee" aria-hidden="true">
      <div className="marquee__track">
        {items.map((title, i) => (
          <span key={i} className="marquee__item">
            {title} <span className="marquee__dot">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
